import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=0fe370d4&name=cta&"
import script from "./Cta.vue?vue&type=script&lang=js&"
export * from "./Cta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports